import { render, staticRenderFns } from "./EditarFrentista.vue?vue&type=template&id=60358d19&"
import script from "./EditarFrentista.vue?vue&type=script&lang=js&"
export * from "./EditarFrentista.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports